<div *ngIf="visible" class="licencia-alert" [ngClass]="{
    'tema-light': variant === 'Light',
    'tema-dark': variant === 'Dark',
    'tema-transparent': variant === 'Transparent',
    'tipo-vencida': tipo === 'vencida',
    'tipo-por-vencer': tipo === 'porVencer'
  }" [style.left]="offsetSidebar" [@slideDown] role="alert">

    <div class="contenido">
        <i class="fas" [ngClass]="tipo === 'vencida' ? 'fa-exclamation-triangle' : 'fa-clock'"></i>
        <span class="texto">{{ mensaje }}</span>
    </div>

    <button type="button" class="btn-cerrar" aria-label="Cerrar" (click)="cerrar()">
        <i class="fas fa-times"></i>
    </button>
</div>